export default "__VITE_ASSET__DTClzxuX__"